import React from "react";
import { generateCRUDRoutes } from "../../../../utils/index";
import { FaCalendarXmark, FaPersonWalkingLuggage, FaSuitcase } from "react-icons/fa6";
import ViewLeave from "./view";
import EditLeave from "./edit";
import { MODULE_TEAM_ABSENCES } from "variables/constants";
import TeamAbsences from "./index";

const teamAbsencesRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Team Absences",
		basePath: "team-absences",
		mainComponent: <TeamAbsences />,
	    layout: "/console",	   
	    icon: <FaCalendarXmark className="icon-item" />,
	    subTitle:"Team Absence",
	    viewComponent: <ViewLeave />,
	    createComponent: <EditLeave />,
	    editComponent: <EditLeave />,
		level:4,
		moduleId: MODULE_TEAM_ABSENCES,
	})
]

export default teamAbsencesRoutes;